import React from 'react';

export default function SchoolCard({ image, place, caption, logo, backgroundColor, color, altText, logoAltText }) {
  return (
    <div className="school">
      <img className="school-picture" src={image} alt={altText} loading="lazy" />

      <div className="school-description" style={{ backgroundColor }}>
        <p className="school-p" style={{ color }}>{place}</p>
        <div className="options">
          <img src={logo} alt={logoAltText} />
        </div>
      </div>

      <div className="caption">{caption}</div>
    </div>
  );
}